import styled from 'styled-components';
import { previewPanelSurface } from '../MessagePreview/previewLayout';
import { WHITE } from '../../appearance/Colors';

const Panel = styled.div`
    flex: 0 0 420px;
    min-width: 300px;
    max-width: min(460px, 34vw);
    height: 100%;
    min-height: 0;
    ${previewPanelSurface};
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 18px 46px rgba(0, 0, 0, 0.28);
    display: flex;
    flex-direction: column;
    position: relative;
    color: ${WHITE};

    @media (max-width: 920px) {
        position: fixed;
        inset: 72px 12px 12px;
        z-index: 2100;
        width: auto;
        max-width: none;
        min-width: 0;
        height: auto;
    }
`;
export default Panel;
